/**
 * Error Handler Utility
 * 
 * Provides consistent error handling and message formatting for API responses
 */

/**
 * Parses API error response and returns appropriate error message
 * @param {Error} error - The error object from API call
 * @returns {string} Formatted error message
 */
export const parseApiError = (error) => {
    // console.log('Error object:', error);
    // console.log('Error response:', error?.response);
    // console.log('Error data:', error?.response?.data);

    if (!error) {
        return 'An unexpected error occurred';
    }

    // Handle network errors
    if (!error.response) {
        return 'Please check your internet connection';
    }

    const { status, data } = error.response;

    // Handle API response with messages.error_messages array
    if (data?.messages?.error_messages?.length > 0) {
        return data.messages.error_messages[0];
    }

    // Handle specific HTTP status codes
    switch (status) {
        case 400:
            return data?.message || 'Invalid request. Please check your input.';
        case 401:
            return data?.message || 'Unauthorized access. Please login again.';
        case 403:
            return data?.message || 'Access forbidden. You do not have permission.';
        case 404:
            return data?.message || 'Resource not found.';
        case 422:
            return data?.message || 'Validation error. Please check your input.';
        case 429:
            return data?.message || 'Too many requests. Please try again later.';
        case 500:
            return data?.message || 'Server error. Please try again later.';
        default:
            return data?.message || 'An unexpected error occurred';
    }
};

/**
 * Handles form validation errors
 * @param {Object} errorFields - Form validation error fields
 * @returns {string} Formatted validation error message
 */
export const parseFormError = (errorFields) => {
    if (!errorFields || !Array.isArray(errorFields)) {
        return 'Please check your input';
    }

    // Get the first validation error message
    const firstError = errorFields[0]?.errors?.[0]?.message;
    return firstError || 'Please check your input';
}; 